---
title: Piano, extra e fatture
parent: Documentazione
parentHref: /docs
---

<script>
  import DomainTlds from "@/components/domain-tlds.svelte"
</script>

# Piano, extra, fatture e pagine legali

## Un unico piano con tutto incluso

TOBY offre un piano completo senza costi di attivazione e senza livelli nascosti:

- **Fatturazione mensile o annuale:** Scegli tra la fatturazione mensile flessibile (cancellabile mensilmente in qualsiasi momento) o quella annuale scontata (pagabile anche tramite fattura). Consulta il [listino prezzi](/it/pricing) per i prezzi attuali.

Ogni abbonamento include:

- **Il proprio dominio** (<DomainTlds />) — incluso il trasferimento di un dominio esistente (Domain-Umzug)
- **1 indirizzo email** (info@...) con una **casella di posta da 15 GB (Maxi-Postfach)** e indirizzi di inoltro illimitati
- **Fino a 15 pagine** — create e gestite tramite chat, voce o caricamento di foto
- **1 lingua aggiuntiva** (2 lingue in totale) con traduzione automatica al momento della pubblicazione
- **Newsletter** con **1.000 email / mese**
- **Analisi dei visitatori** (rispettosa della privacy, senza banner dei cookie)
- **Starter pack per posta** (adesivo per porta e supporto da tavolo QR A5)
- **Hosting nell'UE** con sicurezza SSL automatica

## Extra opzionali

Se la Sua attività cresce oltre i limiti inclusi, può aggiungere moduli flessibili in qualsiasi momento in **Impostazioni → Abbonamento** (cancellabili mensilmente, consulta il [listino prezzi](/it/pricing)):

- **+15 GB di spazio email** (o una casella di posta aggiuntiva)
- **+1 lingua aggiuntiva per il sito web**
- **+15 pagine aggiuntive**
- **+5.000 email newsletter / mese**

## Ottenere una fattura aziendale corretta (Sito web vs. Google Play)

Se gestisce un'attività commerciale, uno studio o un account da libero professionista e necessita di una **fattura aziendale corretta deducibile fiscalmente (ordentliche Rechnung)** con il nome della Sua azienda, l'indirizzo commerciale e l'IVA (MwSt.) indicata separatamente, La preghiamo di notare dove si abbona:

- **Abbonamento sul sito web (tobysite.com tramite Stripe):** Riceve sempre una **fattura aziendale corretta con IVA** da noi, intestata alla Sua attività. Può scaricare tutte le fatture passate e aggiornare l'indirizzo di fatturazione aziendale in qualsiasi momento in **Impostazioni → Abbonamento**.
- **Abbonamento nell'app Android (Acquisto In-App Google Play):** Quando si abbona tramite Google Play, Google elabora il pagamento come commerciante di riferimento ed emette solo una ricevuta di pagamento standard di Google Play. **Non possiamo emettere una fattura aziendale con IVA (ordentliche Rechnung) per gli abbonamenti fatturati tramite Google Play.**

> **Suggerimento:** Può abbonarsi su **tobysite.com** nel Suo browser per ottenere fatture aziendali Stripe corrette e utilizzare comunque le app TOBY per Android e iOS con il Suo account senza costi aggiuntivi.

## Aggiungere l'Impressum (Impressum) e l'Informativa sulla Privacy (Datenschutz)

- **Il Suo testo legale:** Poiché i requisiti legali dipendono dalla struttura della Sua attività, dalla professione e dal paese, **TOBY non genera consulenza legale né scrive testi legali (Impressum o Datenschutzerklärung) autonomamente.**
- **Come aggiungerli:** Semplicemente incolli il testo esistente dell'Impressum o dell'Informativa sulla Privacy nella chat (o lo carichi come documento Word/PDF, oppure chieda a TOBY di copiarlo dal Suo vecchio sito web) e dica *"Metti questo sulla nostra pagina Impressum."* TOBY creerà le pagine e le collegherà in modo ordinato nel footer del Suo sito web.
